import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import { LANGUAGE_KEY } from './constants';

// Use import.meta.glob to preload all language files and import JSON default export directly
const localeModules = import.meta.glob('@/locales/**/*.json', { eager: true, import: 'default', as: 'json' });

function getTranConfigs(lang: string) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const translation: Record<string, any> = {};

  // Dynamically build language configuration
  const moduleKeys = Object.keys(localeModules);
  const langModules = moduleKeys.filter((key) => key.includes(`/${lang}/`));

  langModules.forEach((key) => {
    const fileName = key.split('/').pop()?.replace('.json', '') || '';
    // Since we imported with `import: 'default'`, each entry is the parsed JSON object
    const jsonData = localeModules[key] as Record<string, unknown>;
    if (fileName === 'contractErrors') {
      // Spread contractErrors to the root level
      Object.assign(translation, jsonData);
    } else {
      translation[fileName] = jsonData;
    }
  });

  return { translation };
}

const resources = {
  en: getTranConfigs('en'),
  tr: getTranConfigs('tr'),
  vi: getTranConfigs('vi'),
  es: getTranConfigs('es'),
  fr: getTranConfigs('fr'),
  ja: getTranConfigs('ja'),
  th: getTranConfigs('th'),
};

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem(LANGUAGE_KEY) || 'en',
    react: {
      useSuspense: true,
    },
    fallbackLng: 'en',
    preload: [localStorage.getItem(LANGUAGE_KEY) || 'en'],
    interpolation: { escapeValue: false },
  });

export default i18n;
